import React from 'react';
import { useSelector } from 'react-redux';
import { getRTL } from '@yme/selectors/index';
import { OneTrustStyles } from './OneTrustStyled';
export const OneTrustHelper = () => {
    const isRightToLeft = useSelector(getRTL);
    return React.createElement(OneTrustStyles, { isRightToLeft: isRightToLeft });
};
